import { render, staticRenderFns } from "./wxwl.vue?vue&type=template&id=361422a2"
import script from "./wxwl.vue?vue&type=script&lang=js"
export * from "./wxwl.vue?vue&type=script&lang=js"
import style0 from "./wxwl.vue?vue&type=style&index=0&id=361422a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports